var _line, _line2, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.6,
    y1: 5.4,
    x2: 8.4,
    y2: 5.4,
    stroke: "#56CD9D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.6,
    y1: 7.4,
    x2: 9.4,
    y2: 7.4,
    stroke: "#56CD9D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1.25C3.48122 1.25 2.25 2.48122 2.25 4V20C2.25 21.5188 3.48122 22.75 5 22.75H10V21.25H5C4.30964 21.25 3.75 20.6904 3.75 20V4C3.75 3.30964 4.30964 2.75 5 2.75H17C17.6904 2.75 18.25 3.30964 18.25 4V11H19.75V4C19.75 2.48122 18.5188 1.25 17 1.25H5Z",
    fill: "#56CD9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2222 23.0001C13.2222 20.2774 13.7778 19.6667 17.1111 19.6667C20.4444 19.6667 21 20.278 21 23.0001",
    stroke: "#56CD9D",
    strokeWidth: 1.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.1111,
    cy: 15.7778,
    r: 2.12778,
    stroke: "#56CD9D",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUser);
export default __webpack_public_path__ + "static/media/file-user.8a54c13f08e91df0ae9a171b7f3e2ae1.svg";
export { ForwardRef as ReactComponent };